import { createFileRoute } from "@tanstack/react-router";
import { ManagePage } from "@/features/bookpublic/ManagePage";

/** The guest's booking page, opened from the confirmation mail (X21-MKT-06). Sits outside the _app layout, like the booking page. */
export const Route = createFileRoute("/p/book/manage/$token")({
  component: ManageRoute,
});

function ManageRoute() {
  const { token } = Route.useParams();
  return <ManagePage token={token} />;
}
